import * as React from 'react';
import { DSPopoverProps, DSPopover } from '../Popover';

export type DSNotifierProps = Pick<DSPopoverProps, 'anchorOrigin' | 'transformOrigin'> & {
    render: (props: { onClick: (event: React.MouseEvent<HTMLButtonElement>) => void }) => JSX.Element;
    children: JSX.Element;
};

export type TransformPlacement = {
    horizontal?: 'center' | 'left' | 'right';
    vertical?: 'bottom' | 'center' | 'top';
};

/**
 *
 * @param param0 - param
 * @param param0.children - a jsx element that will be rendered as the popover content
 * @param param0.render - a function that returns a button.  Add the provided `onClick` to the button
 * @param param0.anchorOrigin - the origin on the button to which the popover will attach
 * @param param0.transformOrigin - the origin on the popover to which the button will attach
 * @returns a function component that renders the given button, as well as the children
 * of the component as the content of the popover
 */
export const DSNotifier: React.FC<DSNotifierProps> = ({ anchorOrigin, children, render, transformOrigin }) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const isOpen = Boolean(anchorEl);
    return (
        <>
            {render({ onClick: handleClick })}
            <DSPopover
                anchorEl={anchorEl}
                anchorOrigin={anchorOrigin}
                open={isOpen}
                transformOrigin={transformOrigin}
                onClose={handleClose}
            >
                {children}
            </DSPopover>
        </>
    );
};
DSNotifier.displayName = 'DSNotifier';
